import { useEffect, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import InformationToolTip from "../../../../common/components/InformationToolTip";
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import Inventory2TwoToneIcon from '@mui/icons-material/Inventory2TwoTone';
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone';

export default function StoreArticleZeroSalesToolTip() {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        const clearToolTipOnScroll = () => {
            // Close the tooltip when scrolling
            setTooltipOpen(false);
        };

        window.addEventListener('scroll', clearToolTipOnScroll);
        return () => {
            window.removeEventListener('scroll', clearToolTipOnScroll);
        };
    }, []);

    const infoForTooltip = [
        {
            title: "Alarm Legends",
            section: [
                {
                    icon: <StorefrontTwoToneIcon fontSize="medium" sx={{ color: "#EA324C" }} />,
                    title: "Store Display",
                    info: [
                        "Likely display issue as stock seems to be available.",
                        "CSL ≥ 75% AND Days Supply ≥ 45d (excl rentables).",
                    ]
                },
                {
                    icon: <Inventory2TwoToneIcon fontSize="small" sx={{ color: "#F2AC42" }} />,
                    title: "Stock Problem",
                    info: [
                        "Likely out-of-stock/stock constraint.",
                        "CSL ≤ 75% OR Days Supply ≤ 15d (excl rentables).",
                    ]
                },
                {
                    icon: <ContentPasteSearchTwoToneIcon fontSize="small" sx={{ color: "#1649AE" }} />,
                    title: "Order Setting",
                    info: [
                        "Likely reorder setting issue.",
                        "CSL ≥ 75% AND Days Supply ≥ 15d AND Days Supply < 45d (excl rentables).",

                    ]
                },
                {
                    title: (
                        <>
                            <Box component="span" sx={{ fontWeight: "bold" }}>
                                CSL
                            </Box>
                            <Box component="span" sx={{ fontWeight: "normal" }}>
                                {" ("}
                            </Box>
                            <Box component="span" sx={{ fontStyle: "italic", fontWeight: "normal" }}>
                                Customer Service Level
                            </Box>
                            <Box component="span" sx={{ fontWeight: "normal" }}>
                                {" )"}
                            </Box>
                        </>
                    ),
                    info: [
                        "Quantity Fulfilled ÷ Quantity Ordered (per SKU)."
                    ]
                },
                {
                    title: "Days Supply",
                    info: [
                        "Est. no. of days current store stock lasts: Inventory Value ÷ Average Daily 8 Weeks Rolling Sales at Cost.",
                    ]
                },
                {
                    title: "Rentables",
                    info: [
                        "SKUs with paid display space (e.g., aisles, gondola, end caps).",
                    ]
                },
                {
                    title: "Last Received Date",
                    info: [
                        "Date this SKU was last received into inventory either from vendor or store.",
                    ]
                },
                {
                    title: "Last Sold Date",
                    info: [
                        "Date this SKU last had a sale for this store.",
                    ]
                }
            ]
        }
    ]

    const informationContent = infoForTooltip.map((section, sectionIdx) => (
        <Box key={sectionIdx} mb={2}>
            <Typography variant="body1" fontWeight="bold" my={0.5} mt={sectionIdx === 0 ? 0 : 4}>
                {section.title}
            </Typography>
            {sectionIdx === 0 && <Divider sx={{ borderBottomWidth: '1px', backgroundColor: '#000', mb: 1 }} />}
            {section.section.map((item, itemIdx) => (
                <>
                    <Box key={itemIdx} mb={1}>
                        <Box display="flex" alignItems="center">
                            <Box mr={.5}>{item.icon}</Box>
                            <Typography variant="body2" fontWeight="bold">{item.title}</Typography>
                        </Box>
                        {item.info.map((infoText, infoIdx) => (
                            <Typography variant="body2" key={infoIdx} sx={{ ml: 4, display: 'flex', alignItems: 'flex-start' }}>
                                <li>
                                    {typeof infoText === 'string' ? infoText : infoText}
                                </li>
                            </Typography>
                        ))}
                    </Box>
                    {item.title === 'Order Setting' && <Divider sx={{ borderBottomWidth: '1px', backgroundColor: '#000', mb: 1 }} />}
                </>
            ))}
        </Box>
    ));

    const handleTooltipChange = (value) => {
        setTooltipOpen(value);
    };

    return <InformationToolTip onChange={handleTooltipChange} open={tooltipOpen} information={informationContent} />
}